export default function lazyLoading() {
    const loadingElements = document.querySelectorAll('.loading-element');
    const windowOffset = window.scrollY + window.innerHeight;
    for (const element of loadingElements) {
        const elementOffset = element.offsetTop;
        if (windowOffset - elementOffset > window.innerHeight * 0.2) {
            element.classList.add('element-loaded');
        }
    }
}
